import { jsx as _jsx } from "react/jsx-runtime";
import { CatInputField } from '@blocks-react/components/InputField';
import { useInputController } from '../../../../hooks/form-controllers';
export const AssociatedDealerInput = ({ name, label, placeholder, required = false, disabled = false, isError = false, }) => {
    const { inputField } = useInputController({ name });
    return (_jsx(CatInputField, { ...inputField, fieldId: name, name: name, label: label, title: label, placeholder: placeholder, required: required, disabled: disabled, "data-testid": `${name}-test`, type: "text", className: "data-cs-mask", status: isError ? 'error' : undefined }));
};
